import React, { useEffect, useState } from "react";
import Navbar from "../../../Components/Navbar";
import { useNavigate } from "react-router-dom";
import { apiPostFormData, Create_Api } from "../../../API/Api_Url";
import { toast } from "react-toastify";
import { ArrowLeft, Upload } from "lucide-react";
import { State, City as Citie } from "country-state-city";


function LabourSignUp() {
    const navigate = useNavigate()


    const [SelectedState, setSelectedState] = useState("");
    const [SelectedDistrict, setSelectedDistrict] = useState("");

    const [Districts, setDistricts] = useState([]);
    const [Cities, setCities] = useState([]);

    useEffect(() => {
        if (SelectedState) {
            const stateCities = Citie.getCitiesOfState("IN", SelectedState);

            const uniqueDistricts = [
                ...new Set(stateCities.map((c) => c.stateCode + "-" + c.name)),
            ].map((key) => {
                const parts = key.split("-");
                return { name: parts[1], stateCode: parts[0] };
            });

            setDistricts(uniqueDistricts);
            setSelectedDistrict("");
            setCities([]);
        }
    }, [SelectedState]);

    useEffect(() => {
        if (SelectedDistrict) {
            const allCities = Citie.getCitiesOfState("IN", SelectedState);

            const filtered = allCities.filter(
                (city) => city.name === SelectedDistrict
            );

            setCities(filtered);
        }
    }, [SelectedDistrict]);



    const [IsUploading, setIsUploading] = useState(false);
    const [step, setStep] = useState(1);
    const [fullName, setFullName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [password, setPassword] = useState("");
    const [subRole, setSubRole] = useState("");
    const [location, setLocation] = useState("");
    const [city, setCity] = useState("");
    const [temporaryAddress, setTemporaryAddress] = useState("");
    const [permanentAddress, setPermanentAddress] = useState("");
    const [mainSkill, setMainSkill] = useState("");

    const [preferredJobLocations, setPreferredJobLocations] = useState([SelectedDistrict]);
    const [additionalNotes, setAdditionalNotes] = useState("");
    const [aadharUpload, setAadharUpload] = useState(null);
    const [panUpload, setPanUpload] = useState(null);

    const [bankDetails, setBankDetails] = useState({
        AccountHolderName: "",
        BankName: "",
        AccountNumber: "",
        IFSCCode: "",
        BranchName: "",
        UPIId: "",
    });


    const handleSubmit = async () => {

        const formData = new FormData();
        formData.append("fullName", fullName);
        formData.append("companyName", companyName);
        formData.append("phoneNumber", phoneNumber);
        formData.append("emailAddress", emailAddress);
        formData.append("password", password);

        formData.append("SubRole", subRole);
        formData.append("Location", location);
        formData.append("City", city);
        const residentialAddress = {
            temporary: temporaryAddress,
            permanent: permanentAddress,
        };
        Object.keys(residentialAddress).forEach((key) => {
            formData.append(`residentialAddress[${key}]`, residentialAddress[key]);
        });
        formData.append("mainSkill", mainSkill);
        preferredJobLocations.forEach((spec, index) => {
            formData.append(`preferredJobLocations[${index}]`, spec);
        });
        formData.append("additionalNotes", additionalNotes);

        if (aadharUpload) formData.append("Aadhar", aadharUpload);
        if (panUpload) formData.append("PAN", panUpload);
        Object.keys(bankDetails).forEach((key) => {
            formData.append(`Bankdetails[${key}]`, bankDetails[key]);
        });

        try {
            setIsUploading(true);
            const response = await apiPostFormData("api/labour/register1", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            console.log("Register Successful:", response?.data);
            if (response?.statusCode == 200) {
                localStorage.removeItem("UserType");
                localStorage.removeItem("user");
                localStorage.removeItem("userToken");
                localStorage.setItem("UserType", "labour");
                localStorage.setItem("user", JSON.stringify(response?.data?.labour));
                localStorage.setItem("userToken", response?.data?.token);
                toast.success(response?.message);
                navigate("/");
                setTimeout(() => window.location.reload(), 3000);
            } else {
                toast.error(response?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
            console.error(error);
        } finally {
            setIsUploading(false);
        }
    };

    const validateStep = () => {
        if (step === 1) {
            if (!fullName || !phoneNumber || !emailAddress || !password) {
                toast.error("Please fill all required fields in Basic Information.");
                return false;
            }
            const emailRegex = /\S+@\S+\.\S+/;
            if (!emailRegex.test(emailAddress)) {
                toast.error("Please enter a valid email address.");
                return false;
            }
            if (phoneNumber.length < 10) {
                toast.error("Please enter a valid phone number.");
                return false;
            }
        }
        return true;
    };


    const LabourRole = [
        'Bar Bender / Steel Fixing Team',
        'Carpenter',
        'Plumber',
        'Electrician',
        'Welder / Fabricator'
    ];




    return (
        <>
            <Navbar />
            <div className="AllSignupPadding">
                <div className="flex justify-center">
                    <div className="w-full max-w-4xl bg-white rounded-2xl shadow-xl border border-gray-200 p-10">
                        <div className="relative flex items-center mb-10">
                            <button
                                onClick={() => navigate(-1)}
                                className="absolute left-0 text-gray-700 hover:text-black transition"
                            >
                                <ArrowLeft size={26} />
                            </button>
                            <h1 className="text-3xl font-extrabold text-gray-800 text-center w-full">
                                Architect/Consultants Signup
                            </h1>
                        </div>
                        <div className="flex items-center justify-center mb-8 gap-2 sm:gap-4 w-full px-4 overflow-x-auto">
                            {[1, 2, 3, 4, 5].map((num, index) => (
                                <React.Fragment key={num}>
                                    <div
                                        className={`w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center font-bold ${step >= num
                                            ? "bg-gradient-to-r from-blue-600 to-red-500 text-white"
                                            : "bg-gray-200 text-gray-600"
                                            }`}
                                    >
                                        {num}
                                    </div>
                                    {index < 4 && (
                                        <div
                                            className={`flex-1 h-1 sm:h-1.5 ${step > num
                                                ? "bg-gradient-to-r from-blue-600 to-red-500"
                                                : "bg-gray-300"
                                                }`}
                                        />
                                    )}
                                </React.Fragment>
                            ))}
                        </div>

                        <h2 className="text-2xl font-bold text-center mb-6">
                            {step === 1 && "Basic Information"}
                            {step === 2 && "Professional Details"}
                            {step === 3 && "Additional Information"}
                            {step === 4 && "Document Upload"}
                            {step === 5 && "Bank Details"}
                        </h2>

                        {step === 1 && (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Full Name <span className="text-red-500">*</span></label>
                                    <input
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                        placeholder="Full Name"
                                        value={fullName}
                                        onChange={(e) => setFullName(e.target.value)}
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Phone Number <span className="text-red-500">*</span></label>
                                    <input
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                        placeholder="Phone Number"
                                        value={phoneNumber}
                                        onChange={(e) => setPhoneNumber(e.target.value)}
                                    />
                                </div>

                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Email Address <span className="text-red-500">*</span></label>
                                    <input
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                        type="email"
                                        placeholder="Email Address"
                                        value={emailAddress}
                                        onChange={(e) => setEmailAddress(e.target.value)}
                                    />
                                </div>

                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Password <span className="text-red-500">*</span></label>
                                    <input
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                        type="password"
                                        placeholder="Password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </div>
                            </div>
                        )}

                        {step === 2 && (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Sub Role</label>
                                    <select
                                        value={subRole}
                                        onChange={(e) => setSubRole(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    >
                                        <option value="" disabled>
                                            Select Sub Role
                                        </option>
                                        {LabourRole?.map((role, idx) => (
                                            <option key={idx} value={role}>
                                                {role}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">State</label>
                                    <select
                                        value={SelectedState}
                                        onChange={(e) => setSelectedState(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm bg-white focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                                    >
                                        <option value="">Select State</option>
                                        {State?.getStatesOfCountry("IN")?.map((st) => (
                                            <option key={st.isoCode} value={st?.isoCode}>
                                                {st?.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">District</label>
                                    <select
                                        value={SelectedDistrict}
                                        onChange={(e) => setSelectedDistrict(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm bg-white focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                                    >
                                        <option value="">Select District</option>
                                        {Districts?.map((d, idx) => (
                                            <option key={idx} value={d?.name}>
                                                {d?.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">City</label>
                                    <select
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm bg-white focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                                        value={city}
                                        onChange={(e) => setCity(e.target.value)}
                                    >
                                        <option value="">Select City</option>
                                        {Cities?.map((c, idx) => (
                                            <option key={idx} value={c?.name}>
                                                {c?.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Pincode</label>
                                    <input
                                        type="text"
                                        placeholder="Pincode"
                                        value={location}
                                        onChange={(e) => setLocation(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Temporary Address</label>
                                    <input
                                        type="text"
                                        placeholder="Temporary Address"
                                        value={temporaryAddress}
                                        onChange={(e) => setTemporaryAddress(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Permanent Address</label>
                                    <input
                                        type="text"
                                        placeholder="Permanent Address"
                                        value={permanentAddress}
                                        onChange={(e) => setPermanentAddress(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Main Skill</label>
                                    <input
                                        type="text"
                                        placeholder="Main Skill"
                                        value={mainSkill}
                                        onChange={(e) => setMainSkill(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                            </div>

                        )}

                        {step === 3 && (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div className="col-span-2">
                                    <label className="block mb-2 font-medium text-gray-700">Additional Notes</label>
                                    <textarea
                                        placeholder="Additional Notes"
                                        value={additionalNotes}
                                        onChange={(e) => setAdditionalNotes(e.target.value)}
                                        className="w-full h-24 px-4 py-2 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                            </div>
                        )}

                        {step === 4 && (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Upload PAN Card</label>
                                    <div
                                        className="flex flex-col items-center justify-center w-full h-40 border-2 border-dashed rounded-2xl cursor-pointer hover:border-blue-500 transition relative overflow-hidden"
                                        onClick={() => document.getElementById("panUpload").click()}
                                    >
                                        {panUpload ? (
                                            panUpload.type.startsWith("image/") ? (
                                                <img
                                                    src={URL.createObjectURL(panUpload)}
                                                    alt="Preview"
                                                    className="object-contain h-full w-full"
                                                />
                                            ) : (
                                                <p className="text-sm text-gray-600">{panUpload.name}</p>
                                            )
                                        ) : (
                                            <>
                                                <Upload />
                                                <p className="text-gray-500">Click to upload</p>
                                            </>
                                        )}
                                    </div>
                                    <input
                                        type="file"
                                        id="panUpload"
                                        accept=".pdf,.jpg,.png"
                                        onChange={(e) => setPanUpload(e.target.files[0])}
                                        className="hidden"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Upload Aadhar</label>
                                    <div
                                        className="flex flex-col items-center justify-center w-full h-40 border-2 border-dashed rounded-2xl cursor-pointer hover:border-blue-500 transition relative overflow-hidden"
                                        onClick={() => document.getElementById("aadharUpload").click()}
                                    >
                                        {aadharUpload ? (
                                            aadharUpload.type.startsWith("image/") ? (
                                                <img
                                                    src={URL.createObjectURL(aadharUpload)}
                                                    alt="Preview"
                                                    className="object-contain h-full w-full"
                                                />
                                            ) : (
                                                <p className="text-sm text-gray-600">{aadharUpload.name}</p>
                                            )
                                        ) : (
                                            <>
                                                <Upload />
                                                <p className="text-gray-500">Click to upload</p>
                                            </>
                                        )}
                                    </div>
                                    <input
                                        type="file"
                                        id="aadharUpload"
                                        accept=".pdf,.jpg,.png"
                                        onChange={(e) => setAadharUpload(e.target.files[0])}
                                        className="hidden"
                                    />
                                </div>
                            </div>
                        )}

                        {step === 5 && (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {[
                                    { label: "Account Holder Name", value: bankDetails.AccountHolderName, key: "AccountHolderName" },
                                    { label: "Bank Name", value: bankDetails.BankName, key: "BankName" },
                                    { label: "Account Number", value: bankDetails.AccountNumber, key: "AccountNumber" },
                                    { label: "IFSC Code", value: bankDetails.IFSCCode, key: "IFSCCode" },
                                    { label: "Branch Name", value: bankDetails.BranchName, key: "BranchName" },
                                    { label: "UPI Id", value: bankDetails.UPIId, key: "UPIId" },
                                ].map((field) => (
                                    <div key={field.key}>
                                        <label className="block mb-2 font-medium text-gray-700">{field.label}</label>
                                        <input
                                            className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                            placeholder={field.label}
                                            value={field.value}
                                            onChange={(e) => setBankDetails({ ...bankDetails, [field.key]: e.target.value })}
                                        />
                                    </div>
                                ))}
                            </div>
                        )}


                        <div className="mt-10 flex justify-between">
                            {step > 1 && (
                                <button onClick={() => setStep(step - 1)} className="px-6 py-2 rounded-full bg-gray-400 text-white hover:bg-gray-500 transition">
                                    Back
                                </button>
                            )}
                            {step < 5 ? (
                                <button
                                    onClick={() => {
                                        if (validateStep()) setStep(step + 1);
                                    }}
                                    className="ml-auto px-8 py-3 rounded-full text-white font-semibold shadow-lg bg-gradient-to-r from-blue-600 to-red-500 hover:opacity-90 transition"
                                >
                                    Next →
                                </button>
                            ) : (
                                <button
                                    onClick={handleSubmit}
                                    disabled={IsUploading}
                                    className={`ml-auto px-8 py-3 rounded-full text-white font-semibold shadow-lg bg-gradient-to-r from-blue-600 to-red-500 hover:opacity-90 transition flex items-center justify-center ${IsUploading ? "opacity-70 cursor-not-allowed" : ""
                                        }`}
                                >
                                    {IsUploading ? (
                                        <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                                        </svg>
                                    ) : (
                                        "Submit ✅"
                                    )}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default LabourSignUp;
